import React from "react";
import "./CompositionBarChart.css";
import compositionsTrans from "../../pages/v2/jsons/compositions.json";
import { useTranslation } from "react-i18next";

const colors = ["#0099B0", "#007B8A", "#004D72", "#003366"];
const labelColors = ["#006978", "#006273", "#004D72", "#003366"];

const CompositionBarChart = ({ compositions = [] }) => {
  const { t, i18n } = useTranslation();

  const sortedCompositions = [...compositions].sort(
    (a, b) => (b.value ?? 0) - (a.value ?? 0)
  );

  const getCompositionDescription = (code) => {
    const composition = compositionsTrans.find((c) => c.code === code);
    if (!composition || !composition.description) return t("unknownComposition");

    const lang = i18n.language?.split("-")[0] || "en";
    return (
      composition.description[lang] ||
      composition.description.en ||
      t("unknownComposition")
    );
  };

  return (
    <div className="bar-chart-container">
      {sortedCompositions.map((composition, index) => {
        const color = colors[index % colors.length]; // evita undefined quando há mais de 4
        const labelColor = labelColors[index % labelColors.length];
        const value = composition.value ?? 0;

        return (
          <div key={`${composition.code}-${index}`} className="bar-container">
            <div style={{ color: labelColor }} className="bar-chart-composition-label">
              {getCompositionDescription(composition.code)}
              <div className="bar-chart-composition-value">{value}%</div>
            </div>

            <div className="bar-wrapper">
              <div
                className="bar"
                style={{
                  width: `${Math.max(0, Math.min(100, value))}%`,
                  backgroundColor: color,
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CompositionBarChart;
